(() => {
  const selector = '[data-scc-product-size-guide-dialog]';

  function setupDialog(dialog) {
    if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.sccProductGuideReady === 'true') return;

    /* Look for the trigger in a broader context:
       1. The closest section ancestor of the dialog
       2. Fallback to the entire document */
    const section = dialog.closest('section') || dialog.closest('[id^="shopify-section"]') || document;
    const triggers = section.querySelectorAll('.scc-size-guide-link');
    const closeButtons = dialog.querySelectorAll('[data-scc-product-size-guide-close]');

    dialog.dataset.sccProductGuideReady = 'true';

    triggers.forEach((trigger) => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.setAttribute('aria-label', 'Open size guide');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        dialog.showModal();
        const firstClose = closeButtons[0];
        if (firstClose instanceof HTMLElement) firstClose.focus();
      });
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  function init() {
    document.querySelectorAll(selector).forEach(setupDialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
